import { fetchAuthSession } from 'aws-amplify/auth';

const API = process.env.REACT_APP_SERVER_URL;

const fetchAccessToken = async () => {
    const session = await fetchAuthSession();
    return session.tokens.accessToken.toString();
}

const fetch2 = async (url, body) => {
    const accessToken = await fetchAccessToken();

    /* 
    This function is a wrapper around the fetch API that sends a POST request to the specified URL with the specified body.
    It also checks if the response is ok, and throws an error if it is not.

    Arguments:
    - url: The URL to send the request to
    - body: The body of the request

    Returns:
    - The result of the request
    */
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
        },
        body: JSON.stringify(body)
    });

    // Check if response ok
    if (!response.ok) {
        let errorData;
        try {
            errorData = await response.json(); // Try to parse the error response as JSON
            errorData = errorData.error; // Extract the error message
        } catch (error) {
            errorData = await response.text(); // If parsing as JSON fails, try to parse as text
        }
        throw errorData; // Throw the error data as it is
    }

    const data = await response.json();
    return data.result;
}

const fetchRtTask = async (id) => {
    const accessToken = await fetchAccessToken();

    const response = await fetch(`${API}/rt/task`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
        },
        body: JSON.stringify({
            "func": "getTask",
            "params": {
                "rt_task_id": id
            }
        })
    });
    return await response.json();
}


const fetchDtTask = async (id) => {
    const accessToken = await fetchAccessToken();

    // POST request to https://tasks.gerardantoun.com/api/dt-task
    const response = await fetch(`${API}/dt/task`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`
        },
        body: JSON.stringify({
            "func": "getTask",
            "params": {
                "id": id
            }
        })
    });
    return await response.json();
}

const addRtProcessAndSockets = async (rt_task_id, dt_process_id, io) => {
    const body = {
        "func": "addRtProcessAndSockets",
        "params": {
            "rt_task_id": rt_task_id,
            "dt_process_id": dt_process_id,
            "io": io
        }
    };

    const response = await fetch2(`${API}/rt/task`, body);
    return response;
}

export { 
    fetchDtTask, 
    fetchRtTask, 
    addRtProcessAndSockets 
};